import React, { Component } from 'react'
import { connect } from 'react-redux'

import { isFpBet } from '../../../shared/domainUtils.js'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.scss'
import Loader from '../../../shared/components/Loader.jsx'
import { getLanguageType } from '../../../constants/Language.js'
import Highlights from './banners/highlights/Highlights.jsx'
import JacktopGamesBanner from './banners/jacktop-games/JacktopGamesBanner.jsx'
import LuckyChiken from './banners/lucky-chiken/index.jsx'

const formatErrorMessage = (langType) => {
  const { name = 'en' } = getLanguageType(langType)

  const localization = {
    en: {
      gamesErrorMessage: 'Banner loading error. Please try again later',
    },
    ru: {
      gamesErrorMessage: 'Ошибка загрузки баннера. Повторите попытку позже',
    },
  }
  return localization[name]
}

class Banner extends Component {
  state = {
    activeSlide: 0,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tvBetGame.error !== this.props.tvBetGame.error && this.props.tvBetGame.error) {
      alert(formatErrorMessage(this.props.languageId).gamesErrorMessage)
    }
  }

  render() {
    const { activeSlide } = this.state
    const slides = []
    if (isFpBet) slides.push(Highlights, JacktopGamesBanner, LuckyChiken)
    // if (isUz) slides.push(FastSport)
    
    const moreThan1Slide = slides.length > 1

    const settings = {
      dots: true,
      infinite: moreThan1Slide,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: moreThan1Slide ? '80px' : '0',
      arrows: false,
      focusOnSelect: true,
      customPaging: (i) => <button>{i + 1}</button>,
      beforeChange: (_, next) => this.setState({ activeSlide: next }),
      size: '20px',
      pauseOnHover: false,
      pauseOnFocus: false,
    }

    return (
      <div style={{ marginBottom: 10 }}>
        {this.props.tvBetGame.loading && <Loader />}
        <Slider {...settings}>
          {slides.map((Slide, index) => (
            <div key={index} style={{ paddingRight: '10px' }}>
              <div
                style={{
                  opacity: activeSlide === index ? 1 : 0.5,
                  transition: 'opacity 0.5s',
                }}
              >
                <Slide isActiveSlide={activeSlide === index}/>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    )
  }
}

function select(state) {
  const languageId = state.application.get('languageId')

  const user = state.auth.get('user')
  const accountNum = user ? user.get('accountNum') : null

  return {
    languageId,
    accountNum,
    tvBetGame: state.games.tvbet,
  }
}

export default connect(select)(Banner)



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/Banner.jsx